export const THEME_PRIMARY = "primary";
export const THEME_SECONDARY = "secondary";
